export default function () {
  const trigger   = document.querySelector('.header-wrapper .umenu-trigger-wrapper');

  if(trigger) {
    const umenu_wrapper = document.querySelector('.user-menu-wrapper'),
      umenu = umenu_wrapper.querySelector('.umenu'); // nav
    let menu_height = null;

    trigger.addEventListener('click', function () {
      // menu height va calcolato al momento, perché
      // passando da desktop a mobile, varia la misura
      menu_height = menu_height || umenu.querySelector('.umenu-inner-wrapper').clientHeight;
      umenu_wrapper.classList.toggle('expanded');

      umenu.style.height = umenu_wrapper.classList.contains('expanded') ? menu_height + 'px' : 0;

    }, false);
  }

}
